
export const name = "unsubscribe-ui";
export const version = "dev";
